import {Observable, race} from 'rxjs';
import {map} from 'rxjs/operators';

import {FrontWindow, globalWindow} from '../../libs/shared/helpers/src/browser/browserHelpers';
import {TaskMetadata} from '../../libs/shared/helpers/src/instrumentation/eventLoopPerformanceHelpers';
import {fromHiddenCallback} from './fromHiddenCallback';
import {fromIdleCallback} from './fromIdleCallback';
import {isHidden} from './visibility';

/*
 * Constants.
 */

const hiddenTimeRemaining = 50; // ms.

/*
 * Api.
 */

/** Returns an observable that emits once during an idle callback or when the document is hidden. */
export function fromIdleOrHiddenCallback(
  metadata: TaskMetadata,
  timeout?: number,
  window = globalWindow,
): Observable<IdleDeadline> {
  return race(
    fromIdleCallback(window, metadata, timeout),
    fromHiddenCallback(window).pipe(map(() => buildDeadlineFromHiddenWindow(window))),
  );
}

/*
 * Helpers.
 */

function buildDeadlineFromHiddenWindow(window: FrontWindow): IdleDeadline {
  const timeRemaining = () => {
    // If the window is visible, there is no time remaining.
    if (!isHidden(window)) {
      return 0;
    }

    // Otherwise, there is perpetually 50ms remaining.
    return hiddenTimeRemaining;
  };
  return {
    get didTimeout() {
      return timeRemaining() <= 0;
    },
    timeRemaining,
  };
}
